<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="订单编号">
                  <el-input style="width: 200px" v-model="queryForm.orderNumber"></el-input>
              </el-form-item>
              <el-form-item label="团购商品">
<!--                  <el-input style="width: 200px" v-model="queryForm.groupbuyId"></el-input>-->
                  <GridSelectU style="width: 200px;" title="选择所属账号" labelName="productName"
                               labelValue="id" :value="queryForm.groupbuyId" :limit='1' size='small'
                               placeholder='请选择所属账号'
                               @getValue="getSearchValueGroupbuy" :columns="[
                                   {prop:'productName',label: '商品名称'},
                                   {prop: 'productPic',label: '商品图片',img: 'img'},
                                   {prop:'shopPrice',label: '团购价'}
                               ]" :searchs="[
                                   {prop:'productName',label: '商品名称'}
                               ]"
                               dataListUrl="/shop/storegroupbuy/findList" entityBeanName="shopStoreGroupbuy"
                               queryEntityUrl="/shop/storegroupbuy/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="收件姓名">
                  <el-input style="width: 200px" v-model="queryForm.orderContact"></el-input>
              </el-form-item>
              <el-form-item label="联系电话">
                  <el-input style="width: 200px" v-model="queryForm.orderTel"></el-input>
              </el-form-item>
              <el-form-item label="用户">
<!--                  <el-input style="width: 200px" v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 200px;" title="选择所属账号" labelName="userName"
                               labelValue="id" :value="queryForm.userId" :limit='1' size='small'
                               placeholder='请选择所属账号'
                               @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search"
                               dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                               queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="下单时间">
<!--                  <el-input  v-model="queryForm.orderAddtime"></el-input>-->
                  <el-date-picker
                      v-model="addtimeRange"
                      style="width: 200px"
                      type="datetimerange"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="-"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                  >
                  </el-date-picker>
              </el-form-item>
              <el-form-item label="支付时间">
<!--                  <el-input  v-model="queryForm.orderPaytime"></el-input>-->
                  <el-date-picker
                      v-model="paytimeRange"
                      style="width: 200px"
                      type="datetimerange"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="-"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                  >
                  </el-date-picker>
              </el-form-item>
              <el-form-item label="核销时间">
<!--                  <el-input  v-model="queryForm.orderConfirmtime"></el-input>-->
                  <el-date-picker
                      v-model="delivertimeRange"
                      style="width: 200px"
                      type="datetimerange"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="-"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                  >
                  </el-date-picker>
              </el-form-item>
              <el-form-item label="完成时间">
<!--                  <el-input  v-model="queryForm.orderFinishtime"></el-input>-->
                  <el-date-picker
                      v-model="finishtimeRange"
                      style="width: 200px"
                      type="datetimerange"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="-"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                  >
                  </el-date-picker>
              </el-form-item>
              <el-form-item label="取消时间">
<!--                  <el-input  v-model="queryForm.orderCanceltime"></el-input>-->
                  <el-date-picker
                      v-model="canceltimeRange"
                      style="width: 200px"
                      type="datetimerange"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="-"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                  >
                  </el-date-picker>
              </el-form-item>
              <el-form-item label="订单状态">
<!--                  <el-input style="width: 200px" v-model="queryForm.orderStatus"></el-input>-->
                  <el-select
                      style="width: 200px"
                      size="small"
                      v-model="queryForm.orderStatus"
                  >
                      <el-option v-for="item in orderStatusList" :label="item.value" :value="item.key"> </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="支付类型">
<!--                  <el-input style="width: 200px" v-model="queryForm.payType"></el-input>-->
                  <el-select v-model="queryForm.payType" style="width: 200px" placeholder="请选择支付方式" clearable size="small">
                      <el-option v-for="pageType in payTypeList" :key="pageType.key" :label="pageType.value" :value="pageType.key"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="货币类型">
<!--                  <el-input style="width: 200px" v-model="queryForm.currencyType"></el-input>-->
                  <el-select placeholder="请选择货币类型" clearable v-model="queryForm.currencyType" style="width: 200px">
                      <el-option v-for="item in currencyTypeList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="门店">
<!--                  <el-input style="width: 200px" v-model="queryForm.storeId"></el-input>-->
                  <GridSelectU
                      style="width: 200px"
                      title="选择所属门店"
                      labelName="storeName"
                      labelValue="id"
                      :value="queryForm.storeId"
                      :limit="1"
                      size="small"
                      @getValue="getValueShopId"
                      :columns="STORE_code"
                      :searchs="STORE_search"
                      dataListUrl="/shop/store/findList"
                      entityBeanName="shopStore"
                      queryEntityUrl="/shop/store/get"
                  >
                  </GridSelectU>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopStoreGroupbuyOrderList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addShopStoreGroupbuyOrder"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editShopStoreGroupbuyOrder(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteShopStoreGroupbuyOrder(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          title="导出数据"
          class="icon-box"
          @click="exportShopStoreGroupbuyOrderList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshShopStoreGroupbuyOrderList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopStoreGroupbuyOrderList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="id"-->
<!--        label="ID"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
        <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="groupbuyId"
        label="团购商品"
        width="300"
      >
            <template slot-scope="scope">
                <div class="products" v-if="scope.row.groupbuy">
                    <div class="product">
                        <img :src="scope.row.groupbuy.productPic" alt="">
                        <div class="product-info">
                            <p class="product-name">名称:{{scope.row.groupbuy.productName}}</p>
                            <p class="product-price">团购价:{{scope.row.groupbuy.shopPrice}}</p>
                        </div>
                    </div>
                </div>
                <div class="products" v-else>
                    --
                </div>
            </template>
        </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="orderSize"
            label="订购数量"
            width="180"
        > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderPrice"
        label="订单总价"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="actualPrice"
        label="订单实付金额"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderScore"
        label="订单积分"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderNumber"
        label="订单编号"
        width="180"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="groupbuyId"-->
<!--        label="团购商品"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="orderContact"-->
<!--        label="收件姓名"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="orderTel"-->
<!--        label="联系电话"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="orderRemarks"-->
<!--        label="订单备注"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.user">
                  <div style="text-align: left">账号：{{ scope.row.user.userName ? scope.row.user.userName : '--' }}</div>
                  <div style="text-align: left">昵称：{{scope.row.user.userNickname ? scope.row.user.userNickname : '--' }}</div>
                  <div style="text-align: left">姓名：{{ scope.row.user.userRealname ? scope.row.user.userRealname : '--'}}</div>
                  <div style="text-align: left">手机：{{ scope.row.user.userMobile ? scope.row.user.userMobile : '--' }}</div>
              </div>
          </template>
      </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="left" label="收件信息" width="150">
            <template slot-scope="scope">
                <div style="text-align: left">收货姓名：{{ scope.row.orderContact }}</div>
                <div style="text-align: left">收货电话：{{ scope.row.orderTel }}</div>
                <div style="text-align: left">下单备注：{{ scope.row.orderRemarks }}</div>
            </template>
        </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="storeId"
        label="门店"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.store">
                  <div style="text-align: left">门店名称：{{ scope.row.store.storeName ? scope.row.store.storeName : '' }}</div>
                  <div style="text-align: left">门店地址：{{ scope.row.store.storeAddress ? scope.row.store.storeAddress : '' }}</div>
              </div>
              <div v-else>
                  --
              </div>
          </template>
      </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="left" label="订单信息" width="200">
            <template slot-scope="scope">
                <div style="text-align: left">订单编号：{{ scope.row.orderNumber }}</div>
                <div style="text-align: left" v-if="scope.row.outTradeNo">支付编号：{{ scope.row.outTradeNo }}</div>
                <div style="text-align: left">下单时间：{{ scope.row.orderAddtime }}</div>
                <div style="text-align: left" v-if="scope.row.orderPaytime">支付时间：{{ scope.row.orderPaytime }}</div>
                <div style="text-align: left" v-if="scope.row.orderConfirmtime">核销时间：{{ scope.row.orderConfirmtime }}</div>
                <div style="text-align: left" v-if="scope.row.orderCommenttime">评价时间：{{ scope.row.orderCommenttime }}</div>
                <div style="text-align: left" v-if="scope.row.orderCanceltime">取消时间：{{ scope.row.orderCanceltime }}</div>
                <div style="text-align: left" v-if="scope.row.orderFinishtime">完成时间：{{ scope.row.orderFinishtime }}</div>
                <div style="text-align: left" v-if="scope.row.orderDeletetime">删除时间：{{ scope.row.orderDeletetime }}</div>
            </template>
        </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="orderStatus"
        label="订单状态"
        width="180"
      >
          <template slot-scope="scope">
              <div style="color: red">
                    <span>
                        {{getOrderLabel(Number(scope.row.orderStatus))}}
                    </span>
              </div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="payType"
        label="支付类型"
        width="180"
      >
          <template slot-scope="scope">
              <el-tag type="danger" effect="light" v-if='scope.row.payType'>{{ getPayTypeLabel(scope.row.payType) }}</el-tag>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="payNo"
        label="外部交易号"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="payId"
        label="统一支付ID"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="currencyType"
        label="货币类型"
        width="180"
      >
          <template slot-scope="scope">
              {{ getCurrencyType(scope.row.currencyType) }}
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkShopStoreGroupbuyOrder(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
<!--            <div @click="editShopStoreGroupbuyOrder(scop.row.id)">-->
<!--              <Icon size="16">-->
<!--                <Edit24Regular />-->
<!--              </Icon>-->
<!--              <span class="operation-label">修改</span>-->
<!--            </div>-->
            <div @click="deleteShopStoreGroupbuyOrder(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopStoreGroupbuyOrderStates[shopStoreGroupbuyOrderState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="shopStoreGroupbuyOrder"
          ref="shopStoreGroupbuyOrderForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="订单总价"
            prop="orderPrice"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStoreGroupbuyOrder.orderPrice"
              :disabled="shopStoreGroupbuyOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="订单实付金额"
            prop="actualPrice"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStoreGroupbuyOrder.actualPrice"
              :disabled="shopStoreGroupbuyOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="消耗积分"
            prop="orderScore"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStoreGroupbuyOrder.orderScore"
              :disabled="shopStoreGroupbuyOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="订单编号"
            prop="orderNumber"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStoreGroupbuyOrder.orderNumber"
              :disabled="shopStoreGroupbuyOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="团购商品"
            prop="groupbuyId"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStoreGroupbuyOrder.groupbuyId"
              :disabled="shopStoreGroupbuyOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="订购数量"
            prop="orderSize"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStoreGroupbuyOrder.orderSize"
              :disabled="shopStoreGroupbuyOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="收件姓名"
            prop="orderContact"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStoreGroupbuyOrder.orderContact"
              :disabled="shopStoreGroupbuyOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="联系电话"
            prop="orderTel"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStoreGroupbuyOrder.orderTel"
              :disabled="shopStoreGroupbuyOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="订单备注"
            prop="orderRemarks"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStoreGroupbuyOrder.orderRemarks"
              :disabled="shopStoreGroupbuyOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="用户"
            prop="userId"
            v-if="shopStoreGroupbuyOrder.user"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStoreGroupbuyOrder.user.userName"
              :disabled="shopStoreGroupbuyOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="门店"
            prop="storeId"
            v-if="shopStoreGroupbuyOrder.store"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStoreGroupbuyOrder.store.storeName"
              :disabled="shopStoreGroupbuyOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="所属省份"
            prop="provinceId"
            v-if="shopStoreGroupbuyOrder.province"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStoreGroupbuyOrder.province.name"
              :disabled="shopStoreGroupbuyOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="所属城市"
            prop="cityId"
            v-if="shopStoreGroupbuyOrder.city"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStoreGroupbuyOrder.city.name"
              :disabled="shopStoreGroupbuyOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="所属区县"
            prop="areaId"
            v-if="shopStoreGroupbuyOrder.area"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStoreGroupbuyOrder.area.name"
              :disabled="shopStoreGroupbuyOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="所属街道"
            prop="streetId"
            v-if="shopStoreGroupbuyOrder.street"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStoreGroupbuyOrder.street.name"
              :disabled="shopStoreGroupbuyOrderState == 'check'"
            ></el-input>
          </el-form-item>
            <el-form-item
                label="下单时间"
                prop="orderAddtime"
                v-if="shopStoreGroupbuyOrder.orderAddtime"
            >
                <el-input
                    size="small"
                    style="width: 200px"
                    v-model="shopStoreGroupbuyOrder.orderAddtime"
                    :disabled="shopStoreGroupbuyOrderState == 'check'"
                ></el-input>
            </el-form-item>
          <el-form-item
            label="取消时间"
            prop="orderCanceltime"
            v-if="shopStoreGroupbuyOrder.orderCanceltime"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStoreGroupbuyOrder.orderCanceltime"
              :disabled="shopStoreGroupbuyOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="支付时间"
            prop="orderPaytime"
            v-if="shopStoreGroupbuyOrder.orderPaytime"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStoreGroupbuyOrder.orderPaytime"
              :disabled="shopStoreGroupbuyOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="核销时间"
            prop="orderConfirmtime"
            v-if="shopStoreGroupbuyOrder.orderConfirmtime"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStoreGroupbuyOrder.orderConfirmtime"
              :disabled="shopStoreGroupbuyOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="评价时间"
            prop="orderCommenttime"
            v-if="shopStoreGroupbuyOrder.orderCommenttime"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStoreGroupbuyOrder.orderCommenttime"
              :disabled="shopStoreGroupbuyOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="完成时间"
            prop="orderFinishtime"
            v-if="shopStoreGroupbuyOrder.orderFinishtime"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStoreGroupbuyOrder.orderFinishtime"
              :disabled="shopStoreGroupbuyOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="删除时间"
            prop="orderDeletetime"
            v-if="shopStoreGroupbuyOrder.orderDeletetime"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStoreGroupbuyOrder.orderDeletetime"
              :disabled="shopStoreGroupbuyOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="订单状态"
            prop="orderStatus"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopStoreGroupbuyOrder.orderStatus"-->
<!--              :disabled="shopStoreGroupbuyOrderState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  style="width: 200px"
                  size="small"
                  v-model="shopStoreGroupbuyOrder.orderStatus"
                  :disabled="shopStoreGroupbuyOrderState == 'check'"
              >
                  <el-option v-for="item in orderStatusList" :label="item.value" :value="item.key"> </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="支付类型"
            prop="payType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopStoreGroupbuyOrder.payType"-->
<!--              :disabled="shopStoreGroupbuyOrderState == 'check'"-->
<!--            ></el-input>-->
              <el-select
                  style="width: 200px"
                  size="small"
                  v-model="shopStoreGroupbuyOrder.payType"
                  :disabled="shopStoreGroupbuyOrderState == 'check'"
              >
                  <el-option v-for="item in payTypeList" :label="item.value" :value="item.key"> </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="外部交易号"
            prop="payNo"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStoreGroupbuyOrder.payNo"
              :disabled="shopStoreGroupbuyOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="统一支付ID"
            prop="payId"
          >
            <el-input
              size="small"
              style="width: 200px"
              v-model="shopStoreGroupbuyOrder.payId"
              :disabled="shopStoreGroupbuyOrderState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="货币类型"
            prop="currencyType"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              style="width: 200px"-->
<!--              v-model="shopStoreGroupbuyOrder.currencyType"-->
<!--              :disabled="shopStoreGroupbuyOrderState == 'check'"-->
<!--            ></el-input>-->
              <el-select placeholder="请选择货币类型" clearable :disabled="shopStoreGroupbuyOrderState == 'check'" v-model="shopStoreGroupbuyOrder.currencyType" style="width: 200px">
                  <el-option v-for="item in currencyTypeList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
              </el-select>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopStoreGroupbuyOrderState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { STORE, STORE_SEARCH, USER, USER_SEARCH } from '@/utils/constant';
import GridSelectShop from '@/components/gridselect/gidselect.vue';

export default {
    components: {
        GridSelectShop,
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopStoreGroupbuyOrderList();
                    this.getShopStoreGroupbuyOrderList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopStoreGroupbuyOrderList();
                    this.getShopStoreGroupbuyOrderList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     orderPrice: '', //订单总价
                     actualPrice: '', //订单实付金额
                     orderScore: '', //
                     orderNumber: '', //订单编号
                     groupbuyId: '', //团购商品ID
                     orderSize: '', //订购数量
                     orderContact: '', //收件姓名
                     orderTel: '', //联系电话
                     orderRemarks: '', //订单备注、下单留言
                     userId: '', //用户ID
                     storeId: '', //门店ID
                     provinceId: '', //
                     cityId: '', //
                     areaId: '', //
                     streetId: '', //
                     orderCanceltime: '', //取消时间
                     orderAddtime: '', //下单时间
                     orderPaytime: '', //支付时间
                     orderConfirmtime: '', //核销时间
                     orderCommenttime: '', //评价时间
                     orderFinishtime: '', //完成时间-完成的订单无法售后
                     orderDeletetime: '', //删除时间
                     orderStatus: '', //订单状态
                     payType: '', //支付类型
                     payNo: '', //外部交易号
                     payId: '', //统一支付的一批订单，需要有同一个ID
                     currencyType: '', //货币类型
                    startAddtime: '', //下单开始时间
                    endAddtime: '', //下单结束时间
                    startPayTime: '', //支付开始时间
                    endPayTime: '', //支付结束时间
                    startCancelTime: '', //取消订单开始时间
                    endCancelTime: '', //取消订单结束时间
                    startFinishTime: '', //完成开始时间
                    endFinishTime: '', //完成结束时间
                    startDeliverTime: '', //核销开始时间
                    endDeliverTime: '', //核销结束时间
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopStoreGroupbuyOrderState: 'add',
                shopStoreGroupbuyOrderStates: {
                    add: '新建团购订单',
                    check: '查看团购订单',
                    edit: '修改团购订单'
                },
                STORE_code: STORE,
                STORE_search: STORE_SEARCH,
                payTypeList: [], //支付状态
                orderStatusList: [], //订单状态
                multipleSelection: [],
                shopStoreGroupbuyOrderList: [],
                shopStoreGroupbuyOrder: {
                    id: '', //ID
                    orderPrice: '', //订单总价
                    actualPrice: '', //订单实付金额
                    orderScore: '', //
                    orderNumber: '', //订单编号
                    groupbuyId: '', //团购商品ID
                    orderSize: '', //订购数量
                    orderContact: '', //收件姓名
                    orderTel: '', //联系电话
                    orderRemarks: '', //订单备注、下单留言
                    userId: '', //用户ID
                    storeId: '', //门店ID
                    provinceId: '', //
                    cityId: '', //
                    areaId: '', //
                    streetId: '', //
                    orderCanceltime: '', //取消时间
                    orderAddtime: '', //下单时间
                    orderPaytime: '', //支付时间
                    orderConfirmtime: '', //核销时间
                    orderCommenttime: '', //评价时间
                    orderFinishtime: '', //完成时间-完成的订单无法售后
                    orderDeletetime: '', //删除时间
                    orderStatus: '', //订单状态
                    payType: '', //支付类型
                    payNo: '', //外部交易号
                    payId: '', //统一支付的一批订单，需要有同一个ID
                    currencyType: '', //货币类型
                },
                btnLoading: false,
                currencyTypeList: [],
                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    orderPrice: [{ required: true, message: '订单总价不能为空', trigger: 'blur' }],
                    actualPrice: [{ required: true, message: '订单实付金额不能为空', trigger: 'blur' }],
                    orderScore: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    orderNumber: [{ required: true, message: '订单编号不能为空', trigger: 'blur' }],
                    groupbuyId: [{ required: true, message: '团购商品ID不能为空', trigger: 'blur' }],
                    orderSize: [{ required: true, message: '订购数量不能为空', trigger: 'blur' }],
                    orderContact: [{ required: true, message: '收件姓名不能为空', trigger: 'blur' }],
                    orderTel: [{ required: true, message: '联系电话不能为空', trigger: 'blur' }],
                    orderRemarks: [{ required: true, message: '订单备注、下单留言不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户ID不能为空', trigger: 'blur' }],
                    storeId: [{ required: true, message: '门店ID不能为空', trigger: 'blur' }],
                    provinceId: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    cityId: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    areaId: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    streetId: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    orderCanceltime: [{ required: true, message: '取消时间不能为空', trigger: 'blur' }],
                    orderAddtime: [{ required: true, message: '下单时间不能为空', trigger: 'blur' }],
                    orderPaytime: [{ required: true, message: '支付时间不能为空', trigger: 'blur' }],
                    orderConfirmtime: [{ required: true, message: '核销时间不能为空', trigger: 'blur' }],
                    orderCommenttime: [{ required: true, message: '评价时间不能为空', trigger: 'blur' }],
                    orderFinishtime: [{ required: true, message: '完成时间-完成的订单无法售后不能为空', trigger: 'blur' }],
                    orderDeletetime: [{ required: true, message: '删除时间不能为空', trigger: 'blur' }],
                    orderStatus: [{ required: true, message: '订单状态不能为空', trigger: 'blur' }],
                    payType: [{ required: true, message: '支付类型不能为空', trigger: 'blur' }],
                    payNo: [{ required: true, message: '外部交易号不能为空', trigger: 'blur' }],
                    payId: [{ required: true, message: '统一支付的一批订单，需要有同一个ID不能为空', trigger: 'blur' }],
                    currencyType: [{ required: true, message: '货币类型不能为空', trigger: 'blur' }],
                },

                addtimeRange: [], //下单时间范围
                paytimeRange: [], //付款时间范围
                canceltimeRange: [], //取消时间范围
                finishtimeRange: [], //订单完成时间范围
                delivertimeRange: [], //发货时间

                USER_code: USER,
                USER_search: USER_SEARCH,
            };
        },
        created() {
            this.getShopStoreGroupbuyOrderList();
            this.getPayType();
            this.getOrderStatus();
            this.getCurrencyTypeList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getSearchValueUser(val){
                this.queryForm.userId = val;
            },
            getValueShopId(value){
                this.queryForm.storeId = value
            },
            getSearchValueGroupbuy(val){
                this.queryForm.groupbuyId = val;
            },
            //获取货币类型
            getCurrencyTypeList() {
                get(`/mpp/utils/getEnum`, { enumType: `currency_type` }).then((res) => {
                    if (res.success) {
                        this.currencyTypeList = res.enumList;
                    }
                });
            },
            getCurrencyType(type) {
                for (const index in this.currencyTypeList) {
                    if (this.currencyTypeList[index].key == type) {
                        return this.currencyTypeList[index].value;
                    }
                }
            },
            //根据订单状态值找标签
            getOrderLabel(orderStatus) {
                for (const index in this.orderStatusList) {
                    if (this.orderStatusList[index].key == orderStatus) {
                        return this.orderStatusList[index].value;
                    }
                }
            },
            //根据支付方式值找标签
            getPayTypeLabel(payType) {
                for (const index in this.payTypeList) {
                    if (this.payTypeList[index].key === payType) {
                        //console.log(this.payTypeList[index].value);
                        return this.payTypeList[index].value;
                    }
                }
            },
            //获取支付方式
            getPayType() {
                get('/mpp/utils/getEnum', { enumType: 'order_pay_type' }).then((data) => {
                    if (data.success) {
                        this.payTypeList = data.enumList;
                    }
                });
            },
            //获取订单状态
            getOrderStatus() {
                get('/shop/utils/getEnum', { enumType: 'group_buy_order_status' }).then((data) => {
                    if (data.success) {
                        this.orderStatusList = data.enumList;
                        // console.log(this.orderStatusList);
                    }
                });
            },
            resetShopStoreGroupbuyOrderList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopStoreGroupbuyOrderList = [];
            },
            resetDialog() {
                this.shopStoreGroupbuyOrderState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      orderPrice: '', //订单总价
                      actualPrice: '', //订单实付金额
                      orderScore: '', //
                      orderNumber: '', //订单编号
                      groupbuyId: '', //团购商品ID
                      orderSize: '', //订购数量
                      orderContact: '', //收件姓名
                      orderTel: '', //联系电话
                      orderRemarks: '', //订单备注、下单留言
                      userId: '', //用户ID
                      storeId: '', //门店ID
                      provinceId: '', //
                      cityId: '', //
                      areaId: '', //
                      streetId: '', //
                      orderCanceltime: '', //取消时间
                      orderAddtime: '', //下单时间
                      orderPaytime: '', //支付时间
                      orderConfirmtime: '', //核销时间
                      orderCommenttime: '', //评价时间
                      orderFinishtime: '', //完成时间-完成的订单无法售后
                      orderDeletetime: '', //删除时间
                      orderStatus: '', //订单状态
                      payType: '', //支付类型
                      payNo: '', //外部交易号
                      payId: '', //统一支付的一批订单，需要有同一个ID
                      currencyType: '', //货币类型
                        startAddtime: '', //下单开始时间
                        endAddtime: '', //下单结束时间
                        startPayTime: '', //支付开始时间
                        endPayTime: '', //支付结束时间
                        startCancelTime: '', //取消订单开始时间
                        endCancelTime: '', //取消订单结束时间
                        startFinishTime: '', //完成开始时间
                        endFinishTime: '', //完成结束时间
                        startDeliverTime: '', //核销开始时间
                        endDeliverTime: '', //核销结束时间
                };
                this.addtimeRange = [];
                this.paytimeRange = [];
                this.canceltimeRange = [];
                this.finishtimeRange = [];
                this.delivertimeRange = [];
                this.getShopStoreGroupbuyOrderList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopStoreGroupbuyOrder = {
                      id: '', //ID
                      orderPrice: '', //订单总价
                      actualPrice: '', //订单实付金额
                      orderScore: '', //
                      orderNumber: '', //订单编号
                      groupbuyId: '', //团购商品ID
                      orderSize: '', //订购数量
                      orderContact: '', //收件姓名
                      orderTel: '', //联系电话
                      orderRemarks: '', //订单备注、下单留言
                      userId: '', //用户ID
                      storeId: '', //门店ID
                      provinceId: '', //
                      cityId: '', //
                      areaId: '', //
                      streetId: '', //
                      orderCanceltime: '', //取消时间
                      orderAddtime: '', //下单时间
                      orderPaytime: '', //支付时间
                      orderConfirmtime: '', //核销时间
                      orderCommenttime: '', //评价时间
                      orderFinishtime: '', //完成时间-完成的订单无法售后
                      orderDeletetime: '', //删除时间
                      orderStatus: '', //订单状态
                      payType: '', //支付类型
                      payNo: '', //外部交易号
                      payId: '', //统一支付的一批订单，需要有同一个ID
                      currencyType: '', //货币类型
                };
            },
            submitForm() {
                if (this.shopStoreGroupbuyOrderState == 'add') {
                    this.$refs.shopStoreGroupbuyOrderForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/storegroupbuyorder/add`,{ ...this.shopStoreGroupbuyOrder }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopStoreGroupbuyOrderList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopStoreGroupbuyOrderState == 'edit') {
                    this.$refs.shopStoreGroupbuyOrderForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/storegroupbuyorder/edit`,{ ...this.shopStoreGroupbuyOrder }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopStoreGroupbuyOrderList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopStoreGroupbuyOrder() {
                this.showDialog = true;
                this.shopStoreGroupbuyOrderState = 'add';
            },
            checkShopStoreGroupbuyOrder(shopStoreGroupbuyOrderId) {
                console.log(shopStoreGroupbuyOrderId);
                this.currentShopStoreGroupbuyOrderId = shopStoreGroupbuyOrderId;

                this.getShopStoreGroupbuyOrderById();
                this.showDialog = true;
                this.shopStoreGroupbuyOrderState = 'check';
            },
            editShopStoreGroupbuyOrder(shopStoreGroupbuyOrderId) {
                console.log('shopStoreGroupbuyOrder', shopStoreGroupbuyOrderId);
                if (shopStoreGroupbuyOrderId) {
                    this.currentShopStoreGroupbuyOrderId = shopStoreGroupbuyOrderId;
                    this.getShopStoreGroupbuyOrderById();
                } else {
                    this.shopStoreGroupbuyOrder = { ...this.shopStoreGroupbuyOrder, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopStoreGroupbuyOrderState = 'edit';
            },
            deleteShopStoreGroupbuyOrder(shopStoreGroupbuyOrderId) {
                let ids = '';
                if (shopStoreGroupbuyOrderId) {
                    ids = shopStoreGroupbuyOrderId;
                } else {
                    ids = this.multipleSelection.map((shopStoreGroupbuyOrder) => shopStoreGroupbuyOrder.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/storegroupbuyorder/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopStoreGroupbuyOrderList();
                                this.getShopStoreGroupbuyOrderList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopStoreGroupbuyOrderList() {
                this.resetShopStoreGroupbuyOrderList();
                this.getShopStoreGroupbuyOrderList();
            },
            getShopStoreGroupbuyOrderList(query = {}) {
                this.queryForm.startAddtime = '';
                this.queryForm.endAddtime = '';
                this.queryForm.startPayTime = '';
                this.queryForm.endPayTime = '';
                this.queryForm.startCancelTime = '';
                this.queryForm.endCancelTime = '';
                this.queryForm.startFinishTime = '';
                this.queryForm.endFinishTime = '';
                this.queryForm.startDeliverTime = "";
                this.queryForm.endDeliverTime = "";
                if (this.addtimeRange != null) {
                    this.queryForm.startAddtime = this.addtimeRange[0];
                    this.queryForm.endAddtime = this.addtimeRange[1];
                }
                if (this.paytimeRange != null) {
                    this.queryForm.startPayTime = this.paytimeRange[0];
                    this.queryForm.endPayTime = this.paytimeRange[1];
                }
                if (this.canceltimeRange != null) {
                    this.queryForm.startCancelTime = this.canceltimeRange[0];
                    this.queryForm.endCancelTime = this.canceltimeRange[1];
                }
                if (this.finishtimeRange != null) {
                    this.queryForm.startFinishTime = this.finishtimeRange[0];
                    this.queryForm.endFinishTime = this.finishtimeRange[1];
                }
                if (this.delivertimeRange != null) {
                    this.queryForm.startDeliverTime = this.delivertimeRange[0];
                    this.queryForm.endDeliverTime = this.delivertimeRange[0];
                }
                this.loading = true;
                get(`/shop/storegroupbuyorder/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopStoreGroupbuyOrderList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopStoreGroupbuyOrderById() {
                get(`/shop/storegroupbuyorder/get`,{ id: this.currentShopStoreGroupbuyOrderId }).then((res) =>{
                    if(res.success){
                      this.shopStoreGroupbuyOrder = { ...this.shopStoreGroupbuyOrder, ...res.shopStoreGroupbuyOrder };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopStoreGroupbuyOrderList() {
                //this.btnLoading = true;
                exprotExcel(`/shop/storegroupbuyorder/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/storegroupbuyorder/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/storegroupbuyorder/importData`,formData);
              this.refreshShopStoreGroupbuyOrderList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopStoreGroupbuyOrderList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopStoreGroupbuyOrderList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
.product{
    display: flex;
    align-items: center;
    img{
        width: 60px;
        height: 60px;
    }
    .product-info{
        margin-left: 10px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        p{
            width: 194px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .product-name{
            font-size: 13px;
            color: #333;
            text-align: left;
        }
        .product-price{
            font-size: 13px;
            color: #333;
            text-align: left;
        }
    }
}
</style>